import React from "react";
import "./SingleFilterWrapper.scss";

const SingleFilterWrapper: React.FC = ({ children }) => (
  <div className="single-filter-wrapper">{children}</div>
);

export default SingleFilterWrapper;
